import { useQueryClient } from '@tanstack/react-query';
import { moderationKeys, type ModerationEntityType } from '@/entities/moderation';

/**
 * Refresh everything a decision touches: every queue list, this queue's
 * review cards (approving one slot withdraws its sibling, so the card
 * changes shape) and the cached single requests (their status moved).
 */
export function useInvalidateModeration(entityType: ModerationEntityType) {
  const queryClient = useQueryClient();
  return () => {
    void queryClient.invalidateQueries({ queryKey: moderationKeys.lists() });
    void queryClient.invalidateQueries({
      queryKey: [...moderationKeys.cards(), entityType],
    });
    void queryClient.invalidateQueries({ queryKey: moderationKeys.requests() });
  };
}
